import type { HubView } from "@/components/hub/use-hub-store";
import { ACTIVITY_TYPES } from "@/lib/activities/registry";
import type { ActivityType } from "@/lib/api/activities";
import type { ActionSuggestionLaunchActionId } from "../context/action-suggestion";

export type ActivityToolId = ActivityType;
export type ContentToolId = "swap" | "moment" | "note";

export interface ContentToolConfig {
  id: ContentToolId;
  label: string;
  shortLabel: string;
  createView: HubView;
  suggestionActionIds: readonly ActionSuggestionLaunchActionId[];
}

export const ACTIVITY_TOOL_ORDER: readonly ActivityToolId[] = ACTIVITY_TYPES;

export const CONTENT_TOOLS: readonly ContentToolConfig[] = [
  {
    id: "swap",
    label: "Create a Swap",
    shortLabel: "Swap",
    createView: "create-swap",
    suggestionActionIds: ["start_swap"],
  },
  {
    id: "moment",
    label: "Share a Moment",
    shortLabel: "Moment",
    createView: "create-moment",
    suggestionActionIds: ["share_moment"],
  },
  {
    id: "note",
    label: "Write a Note",
    shortLabel: "Notes",
    createView: "create-note",
    suggestionActionIds: [],
  },
];

const CONTENT_TOOLS_BY_ID = Object.fromEntries(
  CONTENT_TOOLS.map((tool) => [tool.id, tool]),
) as Record<ContentToolId, ContentToolConfig>;

export function contentToolById(id: ContentToolId): ContentToolConfig {
  return CONTENT_TOOLS_BY_ID[id];
}

export function contentToolForSuggestionAction(
  actionId: ActionSuggestionLaunchActionId,
): ContentToolConfig | undefined {
  return CONTENT_TOOLS.find((tool) =>
    tool.suggestionActionIds.includes(actionId),
  );
}
